<template>
  <create-dialog
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'dialog-bhanh-doc-out'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
    :appendToBody="true"
    :modalAppendToBody="true"
  >
    <template #header>
      <div style="padding-left: 32px">
        <h5 class="dialogTitle">Chọn người nhận</h5>
      </div>
    </template>
    <template #body>
      <div class="">
        <div class="select-Unit-BanHanh">
          <banhanh-cc-tree ref="ccTree"></banhanh-cc-tree>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="flex-row flex__left form-button__action" slot="">
        <el-button class="dialogBtnPrimary" @click="save"> Chọn </el-button>
        <el-button
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >
          <i class="fas fa-times-circle"></i>
          &nbsp;Hủy
        </el-button>
      </div>
    </template>
  </create-dialog>
</template>

<script>
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import BanhanhDepartmentTree from "./banhanh-department-tree";
import CreateDialog from "../../common/custom-dialog";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import BanhanhCcTree from "./banhanh-cc-tree";
import utils from '../../../services/utils';

export default {
  name: "banhanh-select-cc-dialog",
  props: ["isOpen", "docId", "selectedToUserIds", "docCode", "type"],
  mixins: [handleRequestErrorMixin],
  components: {
    BanhanhCcTree,
    CreateDialog,
    BanhanhDepartmentTree,
  },

  data() {
    return {
      vbOutgoingDoc: null,
      toUsers: [],
    };
  },

  computed: {
    deptId() {
      return this.$store.getters.userDeptRole.deptId;
    },
  },

  created() {
    this.loadToUsers()
      .then(() => this.$refs.ccTree.setUserDeptRoleHandlers(this.toUsers))
      .then(() =>
        this.$refs.ccTree.markCheckedForSelectedToUsers(this.selectedToUserIds)
      );
  },

  methods: {
    loadToUsers() {
      // Văn bản không ban hành thì cc được tất cả mọi người
      if (this.type && this.type === "IncommingDoc") {
        return userDeptRoleViewService
          .findAllForDocInCC(this.docId)
          .then(
            (response) =>
              (this.toUsers = response.data
                .filter(
                  (x) =>
                    x.isDefaultRole &&
                    x.status === "active" &&
                    x.usersStatus === "active" &&
                    x.deptStatus === "active"
                )
                .sort((item1, item2) =>
                  utils.compareUserDeptRoleView(item1, item2)
                ))
          );
      }
      return userDeptRoleViewService
        .findAllForDocOutCC(this.docCode ? this.deptId : "TCT", this.docId, {
          sort: ["positionOrder", "fullName"],
        })
        .then((response) => (this.toUsers = response.data));
    },

    save() {
      this.$emit("save", {
        selectedToUsers: this.$refs.ccTree.getToHandlers(),
      });
    },
  },
};
</script>

<style scoped>
.select-Unit-BanHanh .content {
  padding: 10px 15px;
  padding-bottom: 0;
  border: 1px solid #ceced2;
  border-radius: 4px;
}

.select-Unit-BanHanh .label {
  color: #2d3e4f;
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 10px;
  margin-top: 7px;
}

.select-Unit-BanHanh .content .listCompanies.scroll-scope {
  margin-top: 5px;
  height: 200px;
  position: relative;
  margin-bottom: 10px;
  width: 100%;
}

.select-Unit-BanHanh .content .listCompanies .company_item {
  margin: 10px 0;
}

.select-Unit-BanHanh .content .listCompanies .company_item .name {
  color: #2d3e4f;
  font-weight: 700;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 25px;
}

.tag_select {
  box-shadow: 0px 0.5px 1.5px rgb(0, 0, 0, 0.05);
  transition: all 0.25s;
}

.tag_select:hover {
  transform: translateY(2px);
  text-decoration: underline;
  transition: 0.15s;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/components/banhanh-select-cc-dialog.vue